import TemplateView from '../../../../TemplateView'

export default class ChooseReportFooter extends TemplateView {

    constructor() {
        super()
    }

    templateHtml() {
        return '<div class="lightBoxFooter">' +
               '   <div class="commitButton"/>' +
               '   <div class="cancelBtn"></div>' +
               '</div>'
    }

    getCommitBtnEl() {
        return this.find('.commitButton')
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ChooseReportFooter.js